import React from "react";
import {
  FaFacebook,
  FaYoutube,
  FaLinkedin,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaInstagram
} from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import FooterListTitle from "./FooterListTitle";

const Footer = () => {
  const location = useLocation();

  // Social icon styles
  const socialStyles = {
    youtube: { color: "#FF0000", fontSize: "1.4em" },
    facebook: { color: "#0866FF", fontSize: "1.4em" },
    linkedin: { color: "#0a66c2", fontSize: "1.4em" },
    whatsapp: { color: "#40c351", fontSize: "1.4em" },
    instagram: { color: "#E1306C", fontSize: "1.4em" },
  };

  return (
    <div className="w-full bg-[#F5F5F3] py-20">
      <div className="max-w-container mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 px-4 gap-10">

        {/* About Section */}
        <div className="col-span-2">
          <FooterListTitle title="About RK Global Trader" />
          <p className="text-base w-full xl:w-[80%] text-justify mb-4">
            RK Global Trader is a leading exporter of fresh fruits and vegetables from India. 
            We connect international buyers with premium agricultural products, ensuring quality, 
            reliability, and timely delivery. Join us and explore global trade opportunities today.
          </p>
          <div className="flex items-center gap-2">
            <a href="https://www.youtube.com/channel/UCEF5TbZReaHEcHKs36ceqXw" target="_blank" rel="noreferrer" aria-label="RK Global Trader YouTube Channel">
              <FaYoutube style={socialStyles.youtube} />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61554237851124" target="_blank" rel="noreferrer" aria-label="RK Global Trader Facebook Page">
              <FaFacebook style={socialStyles.facebook} />
            </a>
            <a href="https://www.linkedin.com/company/rkglobaltraderexportimport" target="_blank" rel="noreferrer" aria-label="RK Global Trader LinkedIn Page">
              <FaLinkedin style={socialStyles.linkedin} />
            </a>
            <a href="https://www.instagram.com/rkglobaltrader_export_import/" target="_blank" rel="noreferrer" aria-label="RK Global Trader Instagram Page">
              <FaInstagram style={socialStyles.instagram} />
            </a>
            <a href="https://wa.me/+919860968617" target="_blank" rel="noreferrer" aria-label="Contact RK Global Trader on WhatsApp">
              <FaWhatsapp style={socialStyles.whatsapp} />
            </a>
          </div>
        </div>

        {/* Product Range */}
        <div>
          <FooterListTitle title="Product Range" />
          <ul className="flex flex-col gap-2">
            <li>
              <Link to="/trade" state={{ data: location.pathname.split("/")[1] }} className="text-base text-lightText hover:text-black hover:underline">
                Agricultural Products Export
              </Link>
            </li>
          </ul>

          <FooterListTitle title="Portfolio" />
          <ul className="flex flex-col gap-2">
            <li>
              <a href="https://www.exportbureau.com/company_report.html?code=191482&name=rk_global_trader" target="_blank" rel="noreferrer">
                <img src="https://www.exportbureau.com/images/link/icon135x30approved.gif" width="135" height="30" alt="RK Global Trader Export Bureau Verified" />
              </a>
            </li>
            <li>
              <a href="https://rkglobaltrader.linker.store/" target="_blank" rel="noreferrer" title="RK Global Trader Business Profile">
                <div className="mgt_logo">
                  <img src="https://gl-t.linker-cdn.net/images/www/glv2/gl_logo.svg" alt="RK Global Trader Business Profile Logo"/>
                </div>
                <p className="mgt_txt font_16 fw-500 text-center m-0">Business Profile</p>
              </a>
            </li>
          </ul>
        </div>

        {/* Branch & Company */}
        <div>
          <FooterListTitle title="Branch" />
          <ul className="flex flex-col gap-2">
            <li>
              <Link to="/contact" state={{ data: location.pathname.split("/")[1] }} className="text-base text-lightText hover:text-black hover:underline">
                Pune, India
              </Link>
            </li>
          </ul>

          <FooterListTitle title="Company" />
          <ul className="flex flex-col gap-2">
            <li>
              <Link to="/about" className="text-base text-lightText hover:text-black hover:underline">
                About RK Global Trader
              </Link>
            </li>
            <li>
              <Link to="/whychooseus" className="text-base text-lightText hover:text-black hover:underline">
                Why Choose Us
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="col-span-2 flex flex-col items-left w-full px-4">
          <FooterListTitle title="Contact Information" />
          <div className="flex items-top gap-2 mb-4">
            <FaMapMarkerAlt className="mt-1"/>
            <div>
              <p>Registered Address:</p>
              <p>
                Gat No-720,721,723(P),733, FERONIA-506, Nyati Elan, Wagholi, Pune, Maharashtra - 412207, India
              </p>
            </div>
          </div>

          <div className="flex items-top gap-2 mb-4">
            <FaPhoneAlt className="mt-1"/>
            <div>
              <p>Phone Numbers:</p>
              <a href="tel:+919860968617" className="phonenumber">+91 98609 68617</a><br/>
              <a href="tel:+918888804149" className="phonenumber">+91 88888 04149</a>
            </div>
          </div>

          <div className="flex items-top gap-2 mb-4">
            <FaEnvelope className="mt-1"/>
            <div>
              <p>Email:</p>
              <a href="mailto:sales@rkglobaltrader.com" className="email">sales@rkglobaltrader.com</a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Footer;
